// extracted by mini-css-extract-plugin
module.exports = {"xml":"CodeHighlighter_xml__xRwOE","preTag":"CodeHighlighter_preTag__qSVlk","text":"CodeHighlighter_text__KYvfF","wrapper":"CodeHighlighter_wrapper__r_dPY"};